"use client"
import dynamic from 'next/dynamic';
import Image from "next/image"
import {
  CheckCircleOutlined,
  EnvironmentOutlined,
  ClockCircleOutlined,
  LaptopOutlined,
  RightOutlined,
  DownloadOutlined,
} from "@ant-design/icons"
import { Button, Card, Collapse, Divider, Row, Col, Timeline, Tag } from "antd"
import Header from "@/components/header"
import FooterBanner from '@/components/footerBanner'
import Footer from "@/components/footer"
const Faq = dynamic(() => import('@/components/faq'));
import { faq_digital, choose_digital } from '@/components/offlineCourse/faq'
import TestimonialCarousel from '@/components/offlineCourse/testimonial-carousel';
import EnrollmentFormModal from '@/components/offlineCourse/enrollment-form-modal';
import { useState } from 'react';
import BrochureDownloadModal from '@/components/offlineCourse/brochure-download-modal';

export default function DigitalMarketingCoursePage() {
  const { Panel } = Collapse
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isBrowcherModalOpen, setIsBrowcherModalOpen] = useState(false)

  const showBrowcherModal = () => {
    setIsBrowcherModalOpen(true)
  }

  const handleBrowcherClose = () => {
    setIsBrowcherModalOpen(false)
  }
  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleClose = () => {
    setIsModalOpen(false)
  }
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      {/* Hero Section */}
      <div className="relative mt-7 px-3 mx-auto w-full lg:w-[95%] 2xl:w-[77%]  overflow-hidden">
        {/* <div className="absolute inset-0 bg-[url('/images/pattern.png')] opacity-10"></div> */}
        <div className=" px-4 py-16 md:py-24 mx-auto">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="space-y-6">
              {/* <div className="inline-block px-3 py-1 rounded-full bg-orange-100 text-orange-600 font-medium text-sm mb-2">
                Digital Marketing Course
              </div> */}
              <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900">
                Become a Certified Digital Marketing Expert with W3era Academy
              </h1>
              <p className="text-xl text-gray-600">
                Learn SEO, Google Ads, Meta Ads, Content Marketing & More from Industry Experts. Gain Hands-on Experience
                with Live Projects.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                {/* Register Button */}
                <button onClick={showModal}
                  className="flex items-center justify-center h-12 px-6
     text-white font-semibold bg-orange hover:bg-lightOrange hover:text-orange border  rounded-md transition duration-300"
                >
                  Register Now
                  <RightOutlined className="ml-2" />
                </button>
                <EnrollmentFormModal isOpen={isModalOpen} onClose={handleClose} />
                {/* Download Brochure Button */}
                <button onClick={showBrowcherModal}
                  className="flex items-center justify-center  px-6 text-orange 
    font-semibold border border-orange hover:bg-lightOrange  rounded-md transition duration-300">
                  Download Course Brochure
                  <DownloadOutlined className="ml-2" />
                </button>
                <BrochureDownloadModal isOpen={isBrowcherModalOpen} onClose={handleBrowcherClose} />
              </div>
            </div>
            <div className="relative">
              <div className="relative z-10">
                <Image
                  src="/images/offline/student-digital-marketing.png"
                  alt="Digital Marketing Course"
                  width={600}
                  height={600}
                  className="rounded-lg shadow-xl"
                />
              </div>
              <div className="absolute top-4 right-4 bg-white p-3 rounded-lg shadow-lg flex items-center gap-2 z-20">
                <Tag color="orange" className="m-0 border-0 bg-orange-100 text-orange-600 px-2 py-1">
                  100% Placement
                </Tag>
              </div>
              <div className="absolute bottom-4 left-4 bg-white p-3 rounded-lg shadow-lg flex items-center gap-2 z-20">
                <Tag color="orange" className="m-0 border-0 bg-orange-100 text-orange-600 px-2 py-1">
                  Live Projects
                </Tag>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Course Overview Section */}
      <div className='bg-orange'>
        <div className="py-16 px-4   mx-auto w-full lg:w-[95%] 2xl:w-[77%]  text-white">
          <div className=" px-4 mx-auto">
            <div className="text-center max-w-3xl mx-auto mb-12">
              <h2 className="text-3xl font-bold mb-4">Digital Marketing Course Overview</h2>
              <p className="">
                Our comprehensive digital marketing course is designed to equip you with the skills needed to excel in
                today's digital landscape. Learn from industry experts and gain hands-on experience.
              </p>
            </div>
            <div className="grid md:grid-cols-2 gap-8 items-start">
              <div>
                <h3 className="text-xl font-bold mb-4">What You Will Learn:</h3>
                <div className="space-y-4">
                  {[
                    {
                      title: "SEO (Search Engine Optimization)",
                      description:
                        "Understand how search engines work and how to optimize websites for higher rankings. Learn on-page and off-page SEO techniques.",
                    },
                    {
                      title: "Google Ads",
                      description:
                        "Gain expertise in Google Ads campaigns, including PPC, SEM, and remarketing to drive targeted traffic.",
                    },
                    {
                      title: "Meta Ads (Facebook & Instagram)",
                      description:
                        "Master paid advertising on Facebook and Instagram to generate high-quality leads and conversions.",
                    },
                    {
                      title: "Content Marketing",
                      description:
                        "Learn how to create engaging content, build a brand story, and reach the right audience.",
                    },
                    {
                      title: "Google Analytics",
                      description:
                        "Understand how to track and analyze your digital marketing efforts for optimization.",
                    },
                  ].map((item, index) => (
                    <div key={index} className="flex gap-3">
                      <div className="flex-shrink-0 mt-1">
                        <CheckCircleOutlined className="text-orange-600 text-lg" />
                      </div>
                      <div>
                        <h4 className="font-semibold text-lg">{item.title}</h4>
                        <p className="">{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="shadow-md bg-[#F56E51] p-4 rounded-lg z-40 relative ">
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <ClockCircleOutlined className="text-orange-600 text-xl" />
                    <div>
                      <p className="">Course Duration</p>
                      <p className="font-semibold">3 to 6 months</p>
                    </div>
                  </div>
                  <Divider className="my-3" />
                  <div className="flex items-center gap-3">
                    <LaptopOutlined className="text-orange-600 text-xl" />
                    <div>
                      <p className="">Mode of Learning</p>
                      <p className="font-semibold">Offline</p>
                    </div>
                  </div>
                  <Divider className="my-3" />
                  <div className="flex items-center gap-3">
                    <EnvironmentOutlined className="text-orange-600 text-xl" />
                    <div>
                      <p className="">Location</p>
                      <p className="font-semibold">Patrakar Colony, Mansarovar, Jaipur</p>
                    </div>
                  </div>
                  <Divider className="my-3" />
                  <button
                    onClick={showModal}
                    className="bg-orange hover:bg-lightorange p  text-white border-orange-600  rounded-md py-2 px-4 border-white border-[1px] hover:bg-white hover:text-orange"
                  >
                    Register Now
                  </button>
                  <EnrollmentFormModal isOpen={isModalOpen} onClose={handleClose} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Why Choose Us Section */}
      <div className="py-16 px-4   mx-auto w-full  lg:w-[95%] 2xl:w-[75%] ">
        <div className=" px-4 mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="text-3xl font-bold mb-4">Why Choose Our Digital Marketing Course?</h2>
            <p className="text-gray-600">
              Our digital marketing course offers numerous advantages that set us apart from other training programs.
            </p>
          </div>
          <div className='flex flex-wrap gap-4'>
            {choose_digital.map((feature, index) => (
              <div className="flex flex-col py-4 px-6  w-full sm:w-[45%] lg:w-[30%] 2xl:w-[24%] bg-lightGrey gap-4 hover:bg-orange smooth1 group rounded-lg">
                {/* <Image src={"/images/Group 1000004312.svg"} width={50} height={50} alt="w3era academy" className="brightness-0 group-hover:brightness-110" /> */}
                <span className="p-3 rounded-full bg-white text-white w-fit ">
                  <Image src={feature.icon} width={40} height={40} alt=''></Image>
                </span>
                <p className="text-2xl text-black font-semibold group-hover:text-white">{feature.title}</p>
                <p className="text-sm text-black font-medium group-hover:text-white">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Course Modules Section */}
      <section className="py-16 border-y-[1px] border-orange bg-white">
        <div className=" px-4 mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="text-3xl font-bold mb-4">Course Modules</h2>
            <p className="text-gray-600">
              Our digital marketing course is structured into comprehensive modules to ensure you gain expertise in all
              key areas.
            </p>
          </div>
          <div className="max-w-4xl mx-auto">
            <Timeline
              mode="left"
              items={[
                {
                  label: <div className="font-bold text-lg">Module 1</div>,
                  children: (
                    <Card className="shadow-sm hover:shadow-md transition-shadow">
                      <h3 className="text-xl font-bold mb-2">Introduction to Digital Marketing</h3>
                      <p className="text-gray-600">
                        Overview of digital marketing, the importance of an online presence, and the current trends.
                      </p>
                    </Card>
                  ),
                  color: "orange",
                },
                {
                  label: <div className="font-bold text-lg">Module 2</div>,
                  children: (
                    <Card className="shadow-sm hover:shadow-md transition-shadow">
                      <h3 className="text-xl font-bold mb-2">SEO (Search Engine Optimization)</h3>
                      <p className="text-gray-600">
                        How search engines rank websites, keyword research, on-page and off-page SEO strategies.
                      </p>
                    </Card>
                  ),
                  color: "orange",
                },
                {
                  label: <div className="font-bold text-lg">Module 3</div>,
                  children: (
                    <Card className="shadow-sm hover:shadow-md transition-shadow">
                      <h3 className="text-xl font-bold mb-2">Google Ads</h3>
                      <p className="text-gray-600">
                        Google Ads account setup, creating effective ad campaigns, managing bids, and tracking results.
                      </p>
                    </Card>
                  ),
                  color: "orange",
                },
                {
                  label: <div className="font-bold text-lg">Module 4</div>,
                  children: (
                    <Card className="shadow-sm hover:shadow-md transition-shadow">
                      <h3 className="text-xl font-bold mb-2">Social Media Marketing (Meta Ads)</h3>
                      <p className="text-gray-600">
                        Understanding Facebook & Instagram ads, creating and optimizing campaigns, and understanding the
                        algorithms.
                      </p>
                    </Card>
                  ),
                  color: "orange",
                },
                {
                  label: <div className="font-bold text-lg">Module 5</div>,
                  children: (
                    <Card className="shadow-sm hover:shadow-md transition-shadow">
                      <h3 className="text-xl font-bold mb-2">Content Marketing</h3>
                      <p className="text-gray-600">
                        Content strategy, content writing, and distribution to engage with the target audience.
                      </p>
                    </Card>
                  ),
                  color: "orange",
                },
                {
                  label: <div className="font-bold text-lg">Module 6</div>,
                  children: (
                    <Card className="shadow-sm hover:shadow-md transition-shadow">
                      <h3 className="text-xl font-bold mb-2">Google Analytics</h3>
                      <p className="text-gray-600">
                        How to set up Google Analytics, track website traffic, analyze behavior, and improve campaigns.
                      </p>
                    </Card>
                  ),
                  color: "orange",
                },
              ]}
            />
          </div>
        </div>
      </section>
      {/* Testimonials Section */}
      <div className='bg-gray-100'>
        <div className="py-16 px-4   mx-auto w-full lg:w-[95%] 2xl:w-[77%] ">
          <div className="xl:container px-4 mx-auto">
            <div className="text-center xl:max-w-3xl mx-auto mb-12">
              <h2 className="text-3xl font-bold mb-4">What Our Students Say</h2>
              <p className="text-gray-600">
                Hear from our students who have successfully completed our digital marketing course and transformed their
                careers.
              </p>
            </div>
            {/* <TestimonialSlider /> */}
            <TestimonialCarousel />
          </div>
        </div>
      </div>
      {/* CTA Section */}
      <section className="py-16 bg-orange  text-white">
        <div className="container px-4 mx-auto">
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold mb-4">Ready to Start Your Digital Marketing Career?</h2>
            <p className="mb-8">
              Enroll now to become a certified digital marketing expert. Take the first step toward a successful career
              in one of the most dynamic fields in the world.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button onClick={showModal}
                className="bg-white rounded-lg  text-orange hover:bg-orange hover:text-white duration-250 border-[1px] hover:border-white border-white h-12 px-8">
                Enroll Now
              </button>
              <EnrollmentFormModal isOpen={isModalOpen} onClose={handleClose} />
              <button onClick={showBrowcherModal}
                className="border-white border-[1px] hover:bg-white hover:text-orange rounded-md duration-250 text-white hover:bg-orange-700 hover:border-white h-12 px-8">
                Download Course Brochure
              </button>
              <BrochureDownloadModal isOpen={isBrowcherModalOpen} onClose={handleBrowcherClose} />
            </div>
          </div>
        </div>
      </section>
      <Faq faqs={faq_digital} title="Frequently Asked Questions" description="Find answers to common questions about our digital marketing course." />
      <FooterBanner />
      <Footer />
    </div>
  )
}
